import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DialogInsService, IconComponent, TooltipDirective } from '@skylab-angular-shared/ui';
import { KsefCollectiveIdentifiersListDialogComponent } from '../../dialogs/ksef-collective-identifiers-list/ksef-collective-identifiers-list-dialog.component';

@Component({
	selector: 'skl-ksef-collective-identifier-cell',
	template: `
	@if (entity().ksefCollectiveIdentifier) {
		<div
			class="cell-icon-wrapper">
			<skl-icon
				class="text--clickable"
				(click)="openDetails()"
				[tooltip]="entity().ksefCollectiveIdentifier"
				color="success"
				name="file"
				size="16px">
			</skl-icon>
		</div>
	}
	`,
	imports: [IconComponent, TooltipDirective],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KsefCollectiveIdentifierCellComponent {
	readonly entity = input.required<{ ksefCollectiveIdentifier: string, ksefDocumentId: string, ksefNumber: string }>();
	#dialogService = inject(DialogInsService);

	openDetails(): void {
		const id = this.entity().ksefDocumentId ||  this.entity().ksefNumber;
		this.#dialogService.showAsync({
			component: KsefCollectiveIdentifiersListDialogComponent,
			componentProps: {
				data: { ksefDocumentId: id }
			}
		})
	}
}
